<template>
    <div class="saturnalia-map-wrapper">
        <iframe src="https://dome-zcmp.maillist-manage.eu/ua/Optin?od=12ba7e549127&zx=14ad033c1f&tD=112f9e53a3340faa&sD=112f9e53a37e289b" frameBorder="0" id="output-frame-id" class="sat-iframe"></iframe>
    </div>
</template>

<script>
export default {
    name: "BookChat",
    head: {
        title: 'Book a chat | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
            }
        ],
        bodyAttrs: {
            class: 'barcode-page'
        }
    }
}
</script>

<style scoped>
.sat-iframe {
    width: 100%;
    height: 1200px;
    min-height: 300px;
    padding: 0;
    margin: 0;
}
</style>
